// ============================================================================
// todo-client-mod -- useDeleteTodo Hook
//
// 删除 Todo 的 Mutation Hook。
// ============================================================================
import { useState } from 'react';
import { getTodoApiClient } from '../todo-api-client.js';
/**
 * 删除 Todo Mutation
 */
export function useDeleteTodo() {
    const [deleting, setDeleting] = useState(false);
    const [error, setError] = useState(null);
    const deleteTodo = async (id) => {
        setDeleting(true);
        setError(null);
        try {
            await getTodoApiClient().deleteTodo(id);
            return true;
        }
        catch (err) {
            const message = err instanceof Error ? err.message : '删除待办事项失败';
            setError(message);
            return false;
        }
        finally {
            setDeleting(false);
        }
    };
    const reset = () => {
        setDeleting(false);
        setError(null);
    };
    return {
        deleting,
        error,
        deleteTodo,
        reset,
    };
}
//# sourceMappingURL=use-delete-todo.js.map